module.exports = __webpack_public_path__ + "img/089-A.eb29ff13.png";